import { components } from "../../services/api/banking/types";
import {
  dictionaryCurrencyName,
  dictionaryCurrencySymbol
} from "../constants/currency";

export function getCurrencyOption(key: components["schemas"]["Currency"]) {
  return {
    value: key,
    label: `${key} (${dictionaryCurrencySymbol[key]})`,
    labels: [dictionaryCurrencyName[key]]
  };
}
